import { FormJourneyItem, LeadForm } from "@plura/shared/types";
import { AnimatePresence, motion } from "framer-motion";
import { useAutoFocusAfterAnimation } from "@plura/client/hooks";
import { useRef } from "react";
import { cn } from "@plura/shared/utils";
import WebsiteInput from "../../../../molecules/WebsiteInput";
import { useFormContext } from "react-hook-form";
import { dynamicQuestionContent, getCurrentResponseScore } from "@plura/shared/lead-forms";

interface Props {
  id: string;
  step: FormJourneyItem
  leadForm: LeadForm;
  editorMode: boolean;
  previewMode: boolean;
  active: boolean;
  onContentClick?: (fieldName: string, blockId: string) => void;
  hiddenFields?: {
    field: string;
    value: string;
  }[];
}

const WebsiteScreen = ({ id, step, editorMode, previewMode, leadForm, active, onContentClick, hiddenFields }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const form = useFormContext();
  const { conversationId, ...userResponses } = form.getValues()
  const currentResponseScore = userResponses
    ? getCurrentResponseScore(userResponses, leadForm)
    : 0

  const shouldFocus = (!editorMode || (editorMode && previewMode)) && active;
  const { wrapperRef } = useAutoFocusAfterAnimation(() => inputRef.current, shouldFocus);

  const handleContentClick = (field: 'content' | 'secondaryContent') => {
    if ((!editorMode || (editorMode && previewMode)) || !onContentClick) return
    onContentClick(field, id)
  }

  return (
    <>
      <div className={cn('questionInner')}>
        <div>
          <h4
            onClick={() => handleContentClick('content')}
            className={
              cn(
                inputRef.current?.value.length && 'semiFade',
                'question',
              )}
          >
            <motion.span
              dangerouslySetInnerHTML={{
                __html: dynamicQuestionContent({
                  content: step.content,
                  score: currentResponseScore,
                  editMode: editorMode,
                  previewMode: previewMode ?? false,
                  hiddenFields,
                  journeyItems: leadForm.journeyItems ?? [],
                  userResponses
                })
              }}
            />
          </h4>
          {
            step.secondaryContent &&
            <p
              onClick={() => handleContentClick('secondaryContent')}
              className={
                cn(
                  inputRef.current?.value.length && 'semiFade',
                  'caption',
                )}
            >
              <motion.span
                dangerouslySetInnerHTML={{
                  __html: dynamicQuestionContent({
                    content: step.secondaryContent,
                    score: currentResponseScore,
                    editMode: editorMode,
                    previewMode: previewMode ?? false,
                    hiddenFields,
                    journeyItems: leadForm.journeyItems ?? [],
                    userResponses
                  })
                }}
              />
            </p>
          }
        </div>
        <div>
          <motion.div ref={wrapperRef} className={'answerInputWrapper'}>
            <AnimatePresence initial={false}>
              <motion.div className={'fieldWrapper'}>
                <WebsiteInput
                  ref={inputRef}
                  id={step.blockId}
                  placeholder="example.com"
                  className={cn('answerInput', !inputRef.current?.value.length && 'empty')}
                  data-gramm="false"
                  data-gramm_editor="false"
                  data-enable-grammarly="false"
                />
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </>
  );
};


export default WebsiteScreen